import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { branchesPatch } from "../../store/branches/actions";
export var useBranchesPatch = function (trigger, body, id) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseBranchesPatch: (_a = state.Branches.responseBranchesPatch) === null || _a === void 0 ? void 0 : _a.data,
            errorBranchesPatch: state.Branches.errorBranchesPatch,
            loadingBranchesPatch: state.Branches.loadingBranchesPatch,
        });
    }), responseBranchesPatch = _a.responseBranchesPatch, errorBranchesPatch = _a.errorBranchesPatch, loadingBranchesPatch = _a.loadingBranchesPatch;
    useEffect(function () {
        if (trigger) {
            dispatch(branchesPatch({
                name: body.data.name,
                code: body.data.code,
                status: body.data.status,
                clientId: body.data.clientId,
            }, id));
        }
    }, [trigger, body.data.clientId]);
    return {
        responseBranchesPatch: responseBranchesPatch,
        errorBranchesPatch: errorBranchesPatch,
        loadingBranchesPatch: loadingBranchesPatch,
    };
};
